import React, { useEffect, useRef, useState } from "react";

export function ListingHeader({ title, breadCrumb, actions, dropdown }) {
  // dropdown: { label?: string, icon?: Component, items: [{ label, onClick?, href?, target? }] }
  const [open, setOpen] = useState(false);
  const ddRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ddRef.current && !ddRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  const handleItemClick = (item) => {
    setOpen(false);
    if (typeof item.onClick === "function") return item.onClick(item);
    if (item.href) return window.open(item.href, item.target || "_self");
  };

  return (
    <div className="header-container">
      <div className="container-fluid px-4 py-3">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1 className="h2 header-title">{title}</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                {breadCrumb.length > 0 &&
                  breadCrumb.map((item, index) => (
                    <li
                      key={index}
                      className={`breadcrumb-item${index === breadCrumb.length - 1 ? " active" : ""}`}
                      aria-current={index === breadCrumb.length - 1 ? "page" : undefined}
                    >
                      {index === breadCrumb.length - 1 ? item.label : <a href={item.href}>{item.label}</a>}
                    </li>
                  ))}
              </ol>
            </nav>
          </div>

          <div className="d-flex align-items-center">
            {actions && actions.length > 0 && (
              <div className="header-actions d-flex gap-2 me-2">
                {actions.map((action, index) => (
                  <button key={index} className={`btn ${action.className}`} onClick={action.onClick}>
                    {action.icon && <action.icon size={18} className="me-1" />}
                    <span>{action.label}</span>
                  </button>
                ))}
              </div>
            )}

            {dropdown && Array.isArray(dropdown.items) && dropdown.items.length > 0 && (
              <div className="position-relative" ref={ddRef}>
                <button
                  type="button"
                  className="btn btn-outline-secondary d-flex align-items-center"
                  onClick={() => setOpen((s) => !s)}
                  aria-haspopup="true"
                  aria-expanded={open}
                >
                  {dropdown.icon && <dropdown.icon size={18} className="me-1" />}
                  <span>{dropdown.label || "More"}</span>
                  <span className="ms-2" aria-hidden>
                    ▾
                  </span>
                </button>

                {open && (
                  <div
                    className="card shadow-sm"
                    style={{
                      position: "absolute",
                      right: 0,
                      top: "calc(100% + 8px)",
                      minWidth: 180,
                      zIndex: 1200,
                      overflow: "hidden",
                    }}
                    role="menu"
                  >
                    {dropdown.items.map((item, idx) => (
                      <button
                        key={idx}
                        type="button"
                        className="dropdown-item btn d-flex align-items-center"
                        style={{ width: "100%", textAlign: "left", padding: "10px 12px", border: "none", background: "transparent" }}
                        onClick={() => handleItemClick(item)}
                      >
                        <span style={{ flex: 1 }}>{item.label}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}